import { toast } from 'react-toastify';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { claimSubmission } from '../../../utilities/API/claimServices';

export const submitClaim = createAsyncThunk(
    'submitClaim', claimSubmission
)

const initialState = {
    isClaimSubmitted: false
}

const claimSubmissionSlice = createSlice({
    name: 'submitClaim',
    initialState,
    reducers: {
        resetClaimSubmission: (state, action) => {
            state.isClaimSubmitted = false;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(submitClaim.pending, (state, action) => {
                // toast.warn("PreQualQuestions pending")
            })
            .addCase(submitClaim.fulfilled, (state, action) => {
                if (action?.payload?.ResponseDetails?.ResponseCode == "010") {
                    state.isClaimSubmitted = true
                    toast.success("Claim created Successfuly")
                } else {
                    toast.error(action?.payload?.ResponseDetails.ResponseMessage)
                }
            })
            .addCase(submitClaim.rejected, (state, action) => {
                // toast.error(action.error.message)
            })
    },
})

export const { resetClaimSubmission } = claimSubmissionSlice.actions
export default claimSubmissionSlice.reducer